import "regenerator-runtime/runtime";
import $ from "jquery";
import { getQueryStringParam, getRelatedMediaType, getSiteContext, getPageNumber, isPaginationEnabled, getLinkFormat } from "./helpers";
import { RelatedMediaGridViewModel, RelatedMediaItem, VERelatedMedia, MediaPreview } from "./types";
import { drawRelatedMedia, renderPagination, renderLoader, renderFeaturedPodcast } from "./rendering";

declare global {
    interface Window {
        veRelatedMedia: VERelatedMedia;
        veDictionary: any;
        epi: any;
    }
}

/**** To drive the Grid Card Functionality ****/
//Any changes done to this will also affect UCITS. Contact Eugene for any questions
$(_ => {

    //Guard - run only if there is an insights grid component on the page
    if( $(".ve-dynamic-related-media").length == 0 ) return;

    /*** veRelatedMedia = the roubust insights grid component designed to interface with the related media service */
    const veRelatedMedia: VERelatedMedia = {
        initialised: false,
        relatedMediaItems: [],
        endpoint: "/Main/RelatedMediaUsBlock/GetMediaWithPaging",
        debug: false,
        shouldScrollIntoView: false,


        /**
         * Accepts the grid object and based on the data available, query the endpoint and obtain the media items.
         * @param {any} relatedMediaItem
         */
        getData: async (relatedMediaItem: RelatedMediaItem, pageOverride?: string, skipUrlUpdate?: boolean) => {
            window.veRelatedMedia.debug ? console.time("Retrive Data for Related Media-" + relatedMediaItem.id) : false;
            if (relatedMediaItem.isContentAreaDriven) {
                try {
                    if (relatedMediaItem.isPaginationEnabled) {
                        renderLoader(relatedMediaItem);
                    }

                    window.veRelatedMedia.endpoint = "/Main/ContentAreaUsBlock/GetRelatedMediaBlocks";
                    
                    const urlParams = new URL(window.location.href).searchParams;
                    const sortingParam = urlParams.get('Sorting');
                    const topicsParam = urlParams.get('Topics');

                    const data: RelatedMediaGridViewModel = await $.get(window.veRelatedMedia.endpoint,
                        {
                            blockId: relatedMediaItem.blockID,
                            pageNumber: pageOverride ?? relatedMediaItem.nextPage,
                            pageSize: relatedMediaItem.count,
                            QueryFormat: relatedMediaItem.insightsType,
                            Author: relatedMediaItem.authorID,
                            Category: relatedMediaItem.categoryID,
                            TopicalTags: relatedMediaItem.topicalTags,
                            ContentTypeTags: relatedMediaItem.contentTypeTags,
                            LocationTags: relatedMediaItem.locationTags,
                            FundTags: relatedMediaItem.fundTags,
                            SiteContext: getSiteContext(relatedMediaItem.siteContext),
                            Lang: relatedMediaItem.lang,
                            Sorting: sortingParam || undefined,
                            Topics: topicsParam || undefined,
                        }
                    );

                    if (data.Result.PageNumber >= data.Result.PageTotalCount) {
                        if (pageOverride) {
                            pageOverride = (parseInt(pageOverride) - 1).toString();
                        } else {
                            relatedMediaItem.nextPage = data.Result.PageTotalCount - 1;
                        }
                        window.veRelatedMedia.getData(relatedMediaItem, pageOverride, skipUrlUpdate);
                        return;
                    }

                    window.veRelatedMedia.debug ? console.timeEnd("Retrive Data for Related Media-" + relatedMediaItem.id) : false;

                    window.veRelatedMedia.debug ? console.log(data) : false;

                    window.veRelatedMedia.debug ? console.time("Render Items for Related Media-" + relatedMediaItem.id) : false;

                    let paginationEnabled = relatedMediaItem.isPaginationEnabled;
                    if (paginationEnabled) {
                        // only scroll if we have the different page loaded
                        window.veRelatedMedia.shouldScrollIntoView = relatedMediaItem.currentPage != data.Result.PageNumber;
                        const scrollOverride = $(relatedMediaItem.element).is(".insights-scroll-to-parent") ? $(relatedMediaItem.element).closest(".container")[0] as HTMLElement : undefined;
                        window.veRelatedMedia.scrollIntoView(scrollOverride);
                        window.veRelatedMedia.shouldScrollIntoView = false;

                        // clear the data so we can render only new data
                        window.veRelatedMedia.clearData(relatedMediaItem);

                        // update the current page
                        relatedMediaItem.currentPage = data.Result.PageNumber;
                    }


                    drawRelatedMedia(relatedMediaItem, data);

                    window.veRelatedMedia.updateDropdownStatus(data.Result, relatedMediaItem);

                    if (paginationEnabled) {
                        window.veRelatedMedia.handlePagination(relatedMediaItem, data, skipUrlUpdate);
                    }
                }
                catch (e) {
                    window.veRelatedMedia.debug ? console.timeEnd("Retrive Data for Related Media-" + relatedMediaItem.id) : false;
                    console.log("Error occured while fetching Related Media Grid Data.");
                    console.error(e);
                }
            }
            else {
                try {
                    if (relatedMediaItem.isPaginationEnabled) {
                        renderLoader(relatedMediaItem);
                    }
                    const urlParams = new URL(window.location.href).searchParams;
                    const sortingParam = urlParams.get('Sorting');
                    const topicsParam = urlParams.get('Topics');
                    
                    const data: RelatedMediaGridViewModel = await $.post(window.veRelatedMedia.endpoint,
                        {
                            pageNumber: pageOverride ?? relatedMediaItem.nextPage,
                            pageSize: relatedMediaItem.count,
                            QueryFormat: relatedMediaItem.insightsType,
                            Author: relatedMediaItem.authorID,
                            Category: relatedMediaItem.categoryID,
                            TopicalTags: relatedMediaItem.topicalTags,
                            ContentTypeTags: relatedMediaItem.contentTypeTags,
                            LocationTags: relatedMediaItem.locationTags,
                            FundTags: relatedMediaItem.fundTags,
                            SiteContext: getSiteContext(relatedMediaItem.siteContext),
                            Lang: relatedMediaItem.lang,
                            Sorting: sortingParam || undefined,
                            Topics: topicsParam || undefined,
                        }
                    );

                    if (data?.Result?.PageNumber && data.Result.PageNumber >= data.Result.PageTotalCount) {
                        if (pageOverride) {
                            pageOverride = (parseInt(pageOverride) - 1).toString();
                        } else {
                            relatedMediaItem.nextPage = data.Result.PageTotalCount - 1;
                        }
                        window.veRelatedMedia.getData(relatedMediaItem, pageOverride, skipUrlUpdate);
                        return;
                    }

                    window.veRelatedMedia.debug ? console.timeEnd("Retrive Data for Related Media-" + relatedMediaItem.id) : false;

                    window.veRelatedMedia.debug ? console.log(data) : false;

                    window.veRelatedMedia.debug ? console.time("Render Items for Related Media-" + relatedMediaItem.id) : false;

                    let paginationEnabled = relatedMediaItem.isPaginationEnabled;
                    if (paginationEnabled) {
                        // only scroll if we have the different page loaded
                        window.veRelatedMedia.shouldScrollIntoView = relatedMediaItem.currentPage != data.Result.PageNumber;
                        const scrollOverride = $(relatedMediaItem.element).is(".insights-scroll-to-parent") ? $(relatedMediaItem.element).closest(".container")[0] as HTMLElement : undefined;
                        window.veRelatedMedia.scrollIntoView(scrollOverride);
                        window.veRelatedMedia.shouldScrollIntoView = false;

                        // clear the data so we can render only new data
                        window.veRelatedMedia.clearData(relatedMediaItem);

                        // update the current page
                        relatedMediaItem.currentPage = data.Result.PageNumber;
                    }

                    drawRelatedMedia(relatedMediaItem, data);

                    window.veRelatedMedia.updateDropdownStatus(data.Result, relatedMediaItem);

                    if (paginationEnabled) {
                        window.veRelatedMedia.handlePagination(relatedMediaItem, data, skipUrlUpdate);
                    }
                }
                catch (e) {
                    window.veRelatedMedia.debug ? console.timeEnd("Retrive Data for Related Media-" + relatedMediaItem.id) : false;
                    console.log("Error occured while fetching Related Media Grid Data.");
                    console.error(e);
                }
            }
        },

        clearData: (relatedMediaItem: RelatedMediaItem) => {
            $(relatedMediaItem.element).find(".draw-area").empty();
            $(relatedMediaItem.element).find(".view-more").removeClass("hide").empty().show();
        },

        handlePagination: (relatedMediaItem: RelatedMediaItem, data: RelatedMediaGridViewModel, skipUrlUpdate?: boolean) => {
            const targetPage = data.Result.PageNumber > data.Result.PageTotalCount
                ? data.Result.PageTotalCount
                : data.Result.PageNumber;
            data.Result.PageNumber = targetPage;
            renderPagination(relatedMediaItem, data);
            if (skipUrlUpdate !== true) {
                window.veRelatedMedia.updatePaginationUrl(targetPage, relatedMediaItem.categoryID, relatedMediaItem.insightsType, relatedMediaItem.id);
            }
            $(relatedMediaItem.element).find(".ve-pagination .btn-pagination").on("click", function (e) {
                e.preventDefault();
                window.veRelatedMedia.getData(relatedMediaItem, $(e.currentTarget as HTMLElement).data("pageid")?.toString() ?? "")
            });
            $(relatedMediaItem.element).find(".page-input").on("change", function (e) {
                // prevent further interactions
                $(e.currentTarget as HTMLElement).attr("disabled", "disabled");
                let targetPage = parseInt($(e.currentTarget as HTMLElement).val()?.toString() ?? "");
                const maxPage = parseInt($(e.currentTarget as HTMLElement).attr("max")?.toString() ?? "");
                if (targetPage > maxPage) {
                    targetPage = maxPage;
                }

                if (targetPage < 1) {
                    targetPage = 1;
                }

                // 0 based indexing, must have - 1 to load proper page
                targetPage -= 1;
                window.veRelatedMedia.getData(relatedMediaItem, targetPage.toString())
            });
        },

         /***
         * Function to read the query strings and then tune the config of the window.veRelatedMedia item.
         * */
        configureGridByQueryStrings: () => {
            //debugger;
            //Try to get the mediaType from the URL
            const mediaType = getQueryStringParam("mediaType");
            const category = getQueryStringParam("category");
            const pageNumber = getPageNumber();
            if (category) {

                const getCategoryFromString = (catString: string) => {
                    const selectedCat = $("#InsightsDropdown .dropdown__item").toArray().find(x => {
                        const matchesCategoryName = $(x).text().toLowerCase().replace(/[ ]/g, "-") === catString;
                        const matchesNameInURL = $(x).data("categoryurlname")?.toLowerCase().replace(/[ ]/g, "-") === catString;
                        return matchesCategoryName || matchesNameInURL;
                    });
                    if (selectedCat) {
                        //return Array [categoryName, categoryID];
                        return [$(selectedCat).text(), $(selectedCat).attr("value")];
                    }
                    return [false, false];
                }

                const getCategoryFromId = (catId: string) => {
                    const selectedCat = $("#InsightsDropdown .dropdown__item").toArray().find(x => $(x).attr("value") == catId);
                    if (selectedCat) {
                        //return Array [categoryName, categoryID];
                        return [$(selectedCat).text(), $(selectedCat).attr("value")];
                    }
                    return [false, false];
                }

                const setCategory = (insightsCategory: string) => {
                    //get the Id and name of the category
                    if (typeof insightsCategory != "string") return false;
                    const catString = insightsCategory.toLowerCase();
                    if (!catString) return false;

                    const [catName, catId] = parseInt(category)
                        ? getCategoryFromId(catString)
                        : getCategoryFromString(catString);

                    if(!catId || !catName || catId === true) return;
                    $(".ve-dynamic-related-media:first").data("categoryid", catId).attr("data-categoryid", catId);
                    $("#InsightsDropdown .dropdown__label").text(catName);
                }

                setCategory(category);
            }

            if (mediaType) {
                //To set the mediatype to the first item.
                const setType = (insightsType: string) => {
                    $(".ve-dynamic-related-media:first").data("insightstype", insightsType).attr("data-insightstype", insightsType);
                    $("#InsightsTypeDropdown .dropdown__label").text(insightsType + "s");
                    insightsType == "All" ? $("#InsightsTypeDropdown .dropdown__label").text("All Formats") : false;
                }

                if (mediaType.toLowerCase() != 'podcast') {
                    window.veRelatedMedia.shouldScrollIntoView = true;
                }

                //we switch so only the relavent ones can be used, all others will be ignored.
                //Also capitalisation of first letter.
                switch (mediaType.toLowerCase()) {
                    case "webinar":
                        setType("Webinar")
                        break;                    
                    case "blog":
                        setType("Blog")
                        break;                    
                    case "video":
                        setType("Video")
                        break;                    
                    case "podcast":
                        setType("Podcast")
                        break;                         
                    case "all":
                        setType("All")
                        break;                    
                    default:
                        return false;
                }
            }

            if (pageNumber && !isNaN(pageNumber) && pageNumber > -1) {
                $(".ve-dynamic-related-media:first").data("nextPage", pageNumber).attr("data-nextPage", pageNumber);
            }

            return false;
        },

        scrollIntoView: (overrideElement) => {
            if (window.veRelatedMedia.shouldScrollIntoView) {
                //scroll into view
                const rmOffset = !overrideElement
                    ? $(".ve-dynamic-related-media:first")[0].offsetTop
                    : overrideElement.offsetTop;

                const scrollDistance = overrideElement
                    ? 45
                    : 15;
                //get category to see if there is a selected category, aka. not a capability page.
                const currentCategory = $(".ve-dynamic-related-media:first").data("category");
                if (rmOffset) { // && !currentCategory) {
                    window.scrollTo(0, rmOffset - scrollDistance);
                }
            }
        },

        updateDropdownStatus: async (data, relatedMediaItem) => {
            const updateCategories = function () {
                const NoCategorySelected = $("#InsightsDropdown .dropdown__label").text().trim() == $("#InsightsDropdown .dropdown__item:first").text().trim();
                $("#InsightsDropdown .dropdown-item").each((i, e) => {
                    const catValue = $(e).attr("value");
                    if (catValue) {
                        const catCount = data.FacetTerms.Categories[catValue];
                        //Do not disable categories if both a media type and category is displayed.
                        if ((!catCount || catCount === 0) && !relatedMediaItem.hasBothCategoryAndMediaType && NoCategorySelected) {  $(e).attr("disabled", "disabled");}
                    }
                    $(e).removeAttr("disabled");
                })
            }

            const updateMediaTypes = function () {
                const AllTypes = $("#InsightsTypeDropdown .dropdown-item:first").attr('value');
                const NoCategorySelected = $("#InsightsDropdown .dropdown__label").text().trim() == $("#InsightsDropdown .dropdown__item:first").text().trim();
                $("#InsightsTypeDropdown .dropdown-item").each((i, e) => {
                    const catValue = $(e).attr("value");
                    if (catValue === AllTypes) return;
                    if (catValue) {
                        const catCount = data.FacetTerms.RelatedMediaTypes[catValue];
                        if ((!catCount || catCount === 0) && !relatedMediaItem.hasBothCategoryAndMediaType && !NoCategorySelected) { $(e).attr("disabled", "disabled"); }
                    }
                    //disable them ONLY if the category was selected, not if both are selected...
                    !relatedMediaItem.hasBothCategoryAndMediaType ? $(e).removeAttr("disabled") : false;
                })
            }

            const hideDropdowns = function () {
                if (!data.MediaTypes) return;

                //see if any of them need to be hidden
                //get list of all media types    
                const MediaTypeKeys = Object.keys(data.MediaTypes);
                //filter those that are false (not available)
                const UnavailableMediaTypes = MediaTypeKeys.filter(x => !data.MediaTypes[x]);
                //if there are nothing to hide ignore.
                if (UnavailableMediaTypes.length == 0) return;

                //get the list of corresponsing values
                const MediaTypesToHide = UnavailableMediaTypes.map(x => !isNaN(x as unknown as number) ? getRelatedMediaType(Number(x)).toLowerCase() : "error")

                window.veRelatedMedia.debug ? console.log("To hide") : false;
                window.veRelatedMedia.debug ? console.log(MediaTypesToHide) : false;

                //iterate through dropdowns and hide if relavent.
                $("#InsightsTypeDropdown .dropdown-item").each((i, e) => {
                    const medValue = $(e).attr("value")?.toLowerCase();
                    if (medValue && MediaTypesToHide.includes(medValue)) {
                        $(e).hide()
                    };
                })
            }

            updateCategories();
            updateMediaTypes();
            hideDropdowns();
        },
        updatePaginationUrl: (pageNumber, categoryId, mediaType, gridId) => {

            // hide RESET button
            pageNumber < 1 ? $(".insights-grid #resetInsights").addClass("d-none") : $(".insights-grid #resetInsights").removeClass("d-none");

            // update view-more button URL
            let url = new URL(window.location.href);
            url.searchParams.set("p", (pageNumber + 1).toString());
            if (categoryId && !$(veRelatedMedia.relatedMediaItems[gridId].element).data("category")) {
                url.searchParams.set("category", categoryId.toString());
            } else {
                url.searchParams.delete("category");
            }

            if (mediaType && mediaType.toLowerCase() != "all") {
                url.searchParams.set("mediaType", mediaType.toString());
            } else {
                url.searchParams.delete("mediaType");
            }

            $("#view-more-button").each((i, e) => {
                $(e).attr("href", url.toString());
            });

            window.history.pushState({ pageNumber: pageNumber, categoryId: categoryId, mediaType: mediaType, gridId: gridId }, document.title, url.toString());
        },
        /**
         * Init Function that reads all related media components and adds them to an object.
         * Then initialises the items and renders them.
         * */
        init: async (ignoreQueryStrings = false) => {

            if (!ignoreQueryStrings) {
                //readQueryStringParams to see if there is an override.
                window.veRelatedMedia.configureGridByQueryStrings();
            }

            $(".ve-dynamic-related-media").each((i, e) => {
                //debugger
                var relatedMediaItem: RelatedMediaItem = {
                    id: i,
                    element: e,
                    blockID: $(e).data("blockid") ?? "",
                    isContentAreaDriven: Boolean($(e).data("contentareadriven")) ?? false,
                    category: $(e).data("category") ?? "", 
                    categoryID: $(e).data("categoryid") ?? "",
                    topicalTags: $(e).data("topicaltags") ?? "", 
                    contentTypeTags: $(e).data("contenttypetags") ?? "", 
                    locationTags: $(e).data("locationtags") ?? "", 
                    fundTags: $(e).data("fundtags") ?? "", 
                    count: $(e).data("count") ?? 6, 
                    insightsType: $(e).data("insightstype") ?? "All",
                    author: $(e).data("author") ?? "",
                    authorID: $(e).data("authorid") ?? "",
                    template: $(e).data("template") ?? "insights-grid",
                    siteContext: $(e).data("sitecontext") ?? "",
                    lang: $(e).data("lang") ?? "",
                    hasBothCategoryAndMediaType: Boolean($(e).data("insightstype")) && Boolean($(e).data("categoryid")) && Boolean($(e).data("insightstype") != "All"),
                    nextPage: $(e).data("nextPage") ?? 0,
                    currentPage: $(e).data("nextPage") ?? 0,
                    isPaginationEnabled: $(e).data("paginationenabled"),
                    linkFormat: getLinkFormat(),
                }
                //debugger
                window.veRelatedMedia.relatedMediaItems.push(relatedMediaItem);

            });


            if (isPaginationEnabled()) {
                window.onpopstate = function (e) {
                    if (!e.state) {
                        return;
                    }

                    window.veRelatedMedia.relatedMediaItems[e.state.gridId].categoryID = e.state.categoryId || "";
                    window.veRelatedMedia.relatedMediaItems[e.state.gridId].insightsType = e.state.mediaType || "";

                    window.veRelatedMedia.getData(window.veRelatedMedia.relatedMediaItems[e.state.gridId], e.state.pageNumber.toString(), true)
                }
            }

            window.veRelatedMedia.relatedMediaItems.forEach(async e => {

                if (!isPaginationEnabled()) {
                    $(e.element).find(".view-more").hide().append(`<button data-ve-gtm="read-more" class="insights-grid__button btn btn-primary no-print">${window.veDictionary.viewMore}</button>`);
                }

                //get the data
                await window.veRelatedMedia.getData(e);

                //bind the button
                $(e.element).find(".view-more .btn-primary").click(async function () {
                    $(this).attr("disabled", "disabled");
                    await window.veRelatedMedia.getData(e)
                });
            })
            //wait for half a ms before scrolling into view
            window.setTimeout(() => window.veRelatedMedia.scrollIntoView(), 200);
            window.veRelatedMedia.initialised = true;
        }
    /* End of window.veRelatedMedia */
    }
    window.veRelatedMedia = veRelatedMedia;
    window.veRelatedMedia.init();

    $(".insights-grid.ve-dynamic-related-media #InsightsDropdown .dropdown-item.dropdown__item").click(function () {
        var clickedCategoryID = $(this).val()?.toString() ?? "";
        var clickedCategoryName = $(this).text();
        $(".ve-dynamic-related-media:first").attr("data-categoryid", clickedCategoryID);
        $(".ve-dynamic-related-media:first").data("categoryid", clickedCategoryID);
        $(".ve-dynamic-related-media:first").data("nextPage", "0").attr("data-nextPage", "0")
        if (window.veRelatedMedia.relatedMediaItems[0].hasBothCategoryAndMediaType) {
            //both category and mediatype are selected, but if a new category is switched, we flip back to all media.
            $(".ve-dynamic-related-media:first").attr("data-insightstype", "All");
            $(".ve-dynamic-related-media:first").data("insightstype", "All");
            $("#InsightsTypeDropdown .dropdown__label").text(window.veDictionary.allFormats);
        }
        $("#InsightsDropdown .dropdown__label").text(clickedCategoryName);
        window.veRelatedMedia.relatedMediaItems.forEach(e => {
            window.veRelatedMedia.clearData(e);
        });
        window.veRelatedMedia.relatedMediaItems = [];
        
        window.veRelatedMedia.init(true);
    });

    $(".insights-grid.ve-dynamic-related-media #InsightsTypeDropdown .dropdown-item.dropdown__item").click(function () {
        var clickedInsightType = $(this).val()?.toString() ?? "";
        var clickedInsightName = $(this).text()?.toString();
        $(".ve-dynamic-related-media:first").attr("data-insightstype", clickedInsightType);
        $(".ve-dynamic-related-media:first").data("insightstype", clickedInsightType);
        $(".ve-dynamic-related-media:first").data("nextPage", "0").attr("data-nextPage", "0")
        $("#InsightsTypeDropdown .dropdown__label").text(clickedInsightName);
        window.veRelatedMedia.relatedMediaItems.forEach(e => {
            window.veRelatedMedia.clearData(e);
        });
        window.veRelatedMedia.relatedMediaItems = [];
        window.veRelatedMedia.init(true);
    });


    //Featured Podcast
    const initFeaturedPodcast = async (podcastPageId: number, languague: string = 'en') => {
        const podcastContainer = document.querySelector('.featured_podcast_container');
        if (!podcastContainer) return;

        const data = await $.get("/Main/PodcastLandingPage/GetFeatured", { podcastPageId, languague });

        if (!data.Success) return false;
        
        const renderedBlock = renderFeaturedPodcast(data.Featured);
        $(podcastContainer).html(renderedBlock)
    }

    const language = document.querySelector('#hdnLanguage') as HTMLInputElement;
    const pageId = document.querySelector('#currentPageId') as HTMLInputElement;
    pageId && initFeaturedPodcast(parseInt(pageId.value), language?.value);

    //Filtration and Sorting
    const initSortingAndFilteringFromUrl = () => {
        const urlParams = new URL(window.location.href).searchParams;
        const sortingParam = urlParams.get('Sorting');
        const topicsParam = urlParams.get('Topics');
    
        if (sortingParam) {
            const selectedOption = $(`#sortingDropdown .dropdown-item.dropdown__item[value="${sortingParam}"]`);
            if (selectedOption.length) {
                $("#sortingDropdown .dropdown__label").text(selectedOption.text());
            }
        }
    
        if (topicsParam) {
            const selectedOption = $(`#topicsDropdown .dropdown-item.dropdown__item[value="${topicsParam}"]`);
            if (selectedOption.length) {
                $("#topicsDropdown .dropdown__label").text(selectedOption.text());
            }
        }
    };

    initSortingAndFilteringFromUrl();

    $('#sortingDropdown .dropdown-item.dropdown__item').on('click', e => {
        const clickedSortingName = $(e.target as HTMLElement).text();
        const clickedSortingValue = $(e.target as HTMLElement).val() as string;
        const currentLabel = $("#sortingDropdown .dropdown__label").text();

        if (currentLabel === clickedSortingName) {
            return;
        }

        $(".ve-dynamic-related-media:first").data("nextPage", "0").attr("data-nextPage", "0");
        $("#sortingDropdown .dropdown__label").text(clickedSortingName);
        
        const url = new URL(window.location.href);
        const firstItem = $('#sortingDropdown .dropdown-item.dropdown__item').first().val() as string;
        
        if (clickedSortingValue && clickedSortingValue !== firstItem) {
            url.searchParams.set('Sorting', clickedSortingValue);
        } else {
            url.searchParams.delete('Sorting');
        }
        
        window.history.replaceState({}, '', url);

        window.veRelatedMedia.relatedMediaItems.forEach(item => {
            window.veRelatedMedia.clearData(item);
        });
        window.veRelatedMedia.relatedMediaItems = [];
        window.veRelatedMedia.init(true);
    });

    $('#topicsDropdown .dropdown-item.dropdown__item').on('click', e => {
        const clickedTopicsName = $(e.target as HTMLElement).text();
        const clickedTopicsValue = $(e.target as HTMLElement).val() as string;
        const currentLabel = $("#topicsDropdown .dropdown__label").text();

        if (currentLabel === clickedTopicsName) {
            return;
        }

        $(".ve-dynamic-related-media:first").data("nextPage", "0").attr("data-nextPage", "0");
        $("#topicsDropdown .dropdown__label").text(clickedTopicsName);
        
        const url = new URL(window.location.href);
        const firstItem = $('#topicsDropdown .dropdown-item.dropdown__item').first().val() as string;
        
        if (clickedTopicsValue && clickedTopicsValue !== firstItem) {
            url.searchParams.set('Topics', clickedTopicsValue);
        } else {
            url.searchParams.delete('Topics');
        }
        
        window.history.replaceState({}, '', url);

        window.veRelatedMedia.relatedMediaItems.forEach(item => {
            window.veRelatedMedia.clearData(item);
        });
        window.veRelatedMedia.relatedMediaItems = [];
        window.veRelatedMedia.init(true);
    });

    // Podcast player logic
    const showPlayer = (src: string) => {
        const player = $('.podcast-player');
        const iframe = player?.find('iframe');

        iframe.attr('src', src)
        player.addClass('show');
    };
   
    $(document).on('click', '.podcast-card__listen-time, .podcast-card__header h3, .grid-card__image-link', (e: JQuery.ClickEvent) => {
        const src = $(e.currentTarget).closest('.grid-card').data('src');
        src && showPlayer(src);
    });

    $(document).on('click', '.podcast-player .close', (e: JQuery.ClickEvent) => {
        const player = $('.podcast-player');
        const iframe = player?.find('iframe');

        player?.removeClass('show');
        iframe.attr('src', '')
    });

    const currentPodcast = $('#playerLink');
    if (currentPodcast?.length && currentPodcast.val()) {
        showPlayer(String(currentPodcast.val()));
    }
})